var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumbnail thumbnail-variables"},[(_vm.hasImage)?_c('AulaImg',{staticClass:"thumbnail-image",attrs:{"img-url":_vm.url,"alt":_vm.title},on:{"error":function($event){_vm.hasImage = false}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }